import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TollMessage } from '@classes/toll-message';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TollMessageService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/tollMessage';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getTollMessages(tollID: string): Observable<Array<TollMessage>> {
    return this.http.get<Array<TollMessage>>(this.basePath + '/' + tollID);
  }

  postTollMessage(tollMessage: TollMessage) {
    return this.http.post<any>(this.basePath,
      tollMessage
    ).pipe(map(m => {
      return m
    }));
  }
  removeError(tollMessage: TollMessage) {

    return this.http.post<any>(this.basePath + '/removeError',
      tollMessage
    );
  }
}

